export default __webpack_public_path__ + "static/media/newsTraining.72404974.png";